export enum PerformanceType {
  SINGER = 'Singer',
  RAPPER = 'Rapper',
  PRODUCER = 'Producer',
  BAND = 'Band',
  COMPOSER = 'Composer',
  OTHER = 'Other',
}
